export default __webpack_public_path__ + "static/media/gallery-img-2.7b84d8ce.png";